"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tenant = exports.SharedDataType = exports.OrgType = void 0;
var OrgType;
(function (OrgType) {
    OrgType["CARRIER"] = "carrier";
    OrgType["CHARTERING_OFFICE"] = "chartering-office";
    OrgType["ORGANIZATION"] = "organization";
})(OrgType = exports.OrgType || (exports.OrgType = {}));
var SharedDataType;
(function (SharedDataType) {
    SharedDataType["CHARTERING"] = "chartering";
    SharedDataType["SENN_TMS"] = "senn_tms";
    SharedDataType["ORCAS"] = "orcas";
    SharedDataType["ORCAS_MOBILE"] = "orcas_mobile";
    SharedDataType["OCTOPUS"] = "octopus";
    SharedDataType["OTTERS"] = "otters";
    SharedDataType["WIDGET"] = "widget";
    SharedDataType["ONBOARDING"] = "onboarding";
})(SharedDataType = exports.SharedDataType || (exports.SharedDataType = {}));
var Tenant;
(function (Tenant) {
    Tenant["SENNDER"] = "sennder";
    Tenant["POSTE"] = "poste";
    Tenant["DEMO"] = "demo";
})(Tenant = exports.Tenant || (exports.Tenant = {}));
__exportStar(require("./mocks"), exports);
